import { Col, Row } from 'antd';
import { Helmet } from 'react-helmet';
import { withNamespaces } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { handleApiErrors } from '../../api/axiosInstance';
import PromptsAPI from '../../api/prompts';
import Box from '../../components/Box';
import PromptForm from '../../components/Forms/PromptForm';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import Toast from '../../components/Toast';
import PageContainer from '../../containers/PageContainer';
import { INTERNAL_LINKS } from '../../enum';
import withAuthentication from '../../hocs/withAuthentication';
import { formatPageTitle } from '../../utils/common';

const CreatePromptView = props => {
  const { history, t } = props;
  const queryClient = useQueryClient();

  const createPromptMutation = useMutation(data => PromptsAPI.createPrompt(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetchPrompts'], { exact: false });
      Toast({
        type: 'success',
        message: t('createPromptSuccess'),
      });
      history.push(INTERNAL_LINKS.PROMPTS);
    },
    onError: error => {
      handleApiErrors(error.response, () => {
        Toast({
          type: 'error',
          message: t('createPromptError'),
        });
      });
    },
  });

  return (
    <PageContainer
      title={
        <PageBreadcrumbs
          items={[
            { label: t('prompts'), onClick: () => history.push(INTERNAL_LINKS.PROMPTS) },
            { label: t('create') },
          ]}
        />
      }
    >
      <Helmet>
        <title>{formatPageTitle('Create Prompt')}</title>
      </Helmet>

      <Row justify="center">
        <Col flex="832px">
          <Box>
            <PromptForm
              t={t}
              loading={createPromptMutation.isLoading}
              disabled={createPromptMutation.isLoading}
              onFinish={createPromptMutation.mutateAsync}
              onCancel={() => history.push(INTERNAL_LINKS.PROMPTS)}
            />
          </Box>
        </Col>
      </Row>
    </PageContainer>
  );
};

export default withNamespaces()(withAuthentication(CreatePromptView));
